import '@fontsource-variable/inter';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { env } from '@/shared/config/env';
import { App } from './App';

async function start() {
  // Compared against the raw string so the bundler drops the mock API (and its seed data)
  // from builds made with VITE_USE_MOCKS=false.
  if (import.meta.env.VITE_USE_MOCKS !== 'false' && env.VITE_USE_MOCKS) {
    const { worker } = await import('@/mocks/browser');
    await worker.start({ onUnhandledRequest: 'bypass', quiet: true });
  }
  const root = document.getElementById('root');
  if (!root) throw new Error('Root element #root is missing from index.html');
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void start();
